export const setRequiredLabel = (label: string) => (
	<div>
		{label} <span style={{color: 'var(--warning-500)'}}>*</span>
	</div>
);
